import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const groceryBag = require("@/images/Grocery_Bag.png");
const sonny = require("@/images/sonny.png");

const findBag = [
  new Dialog(
    "[FOUND 1x RE-USABLE GROCERY BAG]",
    groceryBag,
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "SONNY YANG: Looks like I'm all ready to go. Onwards, to the supermarket!",
    sonny,
    require("@/audio/Pandemic_5_Sonny-MP3.mp3")
  ),
];

const endingDialog = [
  new Dialog(
    "[FOUND 'HAND SANITIZER']",
    require("@/images/Sanitizer.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "SONNY YANG: My SANITIZER! You’re a sight for sore eyes let me tell you.",
    sonny,
    require("@/audio/Pandemic-189-Sonny-1-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: I’ll just apply a sizeable dose to my hands and face and hopefully I’ll be right as rain.",
    sonny,
    require("@/audio/Pandemic-189-Sonny-2-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: What the… hold on a minute.This… This isn’t sanitizer.It… it’s…",
    sonny,
    require("@/audio/Pandemic-189-Sonny-3-MP3.mp3")
  ),
  new Dialog(
    "DARETH: It’s YOGHURT Sonny Yang.",
    require("@/images/Dareth_with_Phone.png"),
    require("@/audio/Pandemic-189-Dareth-1-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Dareth Schamren! What is the meaning of this and what are you doing with that smartphone!?",
    sonny,
    require("@/audio/Pandemic-189-Sonny-4-MP3.mp3")
  ),
  new Dialog(
    "DARETH: I switched the contents of the bottle with yoghurt in anticipation of your schemes! Now I’m filming a video of you which I’ll post to social media under the caption “Silly Chinese Man selfishly smothering yoghurt all over himself during the global YOGID crisis”.You fell right into my trap Sonny Yang!",
    require("@/images/Dareth_with_Phone.png"),
    require("@/audio/Pandemic-189-Dareth-2-MP3.mp3")
  ),

  new Dialog(
    "SONNY YANG: You... how could you!?",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-189-Sonny-5-MP3.mp3")
  ),

  new Dialog(
    "DARETH: As the video goes viral, you will become a social pariah. The world will come after you with all the anger and vitriol it can muster. Enjoy the perennial harassment and racial attacks Sonny Yang. I know I will.",
    require("@/images/Dareth_with_Phone.png"),
    require("@/audio/Pandemic-189-Dareth-3-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: No, no it… it cannot be true! I… I can’t live in this world any longer.I have to run. I have to go… anywhere but here!",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-189-Sonny-6-MP3.mp3")
  ),
  new Dialog(
    "[You hijack a motorcycle from the street outside and you ride off into the sunset!]",
    require("@/images/Sonny_Yang_Motorcycle.png"),
    require("@/audio/Defeat_Jingle.mp3")
  ),
  new Dialog(
    "YOUNG BOY: Dad, why is Sonny Yang riding away ? He didn’t do anything wrong!",
    require("@/images/Son.png"),
    require("@/audio/Pandemic-189-Kid-MP3.mp3")
  ),
  new Dialog(
    "FATHER: I have no idea who that is.",
    require("@/images/Dad.png"),
    require("@/audio/Pandemic-189-Dad-MP3.mp3")
  ),
];

export class LivingRoom extends Scene {
  timesVisited = 0;
  title = "Living Room";
  image = require("@/images/Sonnys_Living_Room.png");
  hideOptions = false

  description = "";

  get options(): any[] {
    if (this.hideOptions) {
      return []
    }

    return [
      new Choice("Leave House", async () => {
        if (this.state.inventory.bag.has) {
          await this.navigate(scenes.HouseExterior());
        } else {
          this.audio = require("@/audio/Pandemic_3_Sonny-MP3.mp3");
          this.description =
            "SONNY YANG: I can’t leave until I find my REUSABLE GROCERY BAG.";
        }
      }),
      new Choice("Look on Book Case", () => {
        this.audio = require("@/audio/Pandemic_4_Sonny-MP3.mp3");
        this.description =
          "SONNY YANG: Nothing here but my collection of leather-bound classics.";
      }),
      new Choice("Check Behind Couch", async () => {
        if (this.state.inventory.bag.has) {
          if (this.state.storylines.infectedWithYogid) {
            this.isFullscreen = true;
            this.title = "The End";
            this.hideOptions = true
            await this.dialogRunner(endingDialog)
            this.state.finished = true
          } else {
            this.audio = null;
            this.description = "[Behind the couch is empty]";
          }
        } else {
          await this.dialogRunner(findBag)
          this.state.inventory.bag.has = true;
          this.state.storylines.findBag = false;
          this.state.storylines.findSupermarket = true;
        }
      }),
    ];
  }
}

export default new LivingRoom();
